import branch from 'branch-sdk';

let initialized = false;

export const initBranch = () => {
  if (typeof window === 'undefined') return;
  if (initialized) return;

  branch.init(process.env.GATSBY_BRANCH_KEY, (err, data) => {
    if (err) {
      console.error('Branch init error:', err);
      return;
    }

    console.log('Branch session data:', data);
  });

  initialized = true;
};
